var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from "react";
export var useRolForm = function (_a) {
    var dataFormRoles = _a.dataFormRoles, setDataFormRoles = _a.setDataFormRoles, onSubmit = _a.onSubmit;
    var isFormValid = dataFormRoles.name.trim() !== "" && dataFormRoles.description.trim() !== "";
    var handleInputChange = useCallback(function (field) {
        return function (event) {
            setDataFormRoles(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[field] = event.target.value, _a)));
            });
        };
    }, [setDataFormRoles]);
    var handleSubmit = useCallback(function () {
        if (!isFormValid)
            return;
        onSubmit(dataFormRoles);
    }, [isFormValid, onSubmit, dataFormRoles]);
    return {
        isFormValid: isFormValid,
        handleInputChange: handleInputChange,
        handleSubmit: handleSubmit,
    };
};
